
import Vue, { PropType } from 'vue'
import { BulkGatewaysTransactionRow } from '@/models'
import moment from 'moment'

export default Vue.extend({
  name: 'GatewayListItem',

  props: {
    row: Object as PropType<BulkGatewaysTransactionRow>,
    no: Number as PropType<number>
  },

  computed: {
    statusTextClass(): string {
      return this.row?.status !== '登録可能' ? 'red' : ''
    },
  }
})
